import { gql } from "@apollo/client";
import { useRouter } from "next/router";
import { client } from "../../../../lib/apollo";
import { guidePageAllGuideQuery, guidePageSingleGuideQuery } from "../../../../lib/queries/guidePage";
import { languageQuery } from "../../../../lib/queries/language";
import { useLanguageContext } from "../../../../src/context/LanguageContext";
import Guide from "../../Guide/Guide";

const GuidePages = ({ singleGuide, allGuide }: any) => {
  const { lang } = useLanguageContext();
  const router = useRouter();
  const dataParent = allGuide[lang.code].data?.allGuide?.nodes?.find((el: any) => el.slug === router.query.href);
  let dataSub;

  if (dataParent.children?.nodes?.length > 0) {
    dataSub = dataParent.children.nodes.find((subEl: any) => subEl.slug === router.query.sub);
  }

  return <Guide guidePageData={dataSub} sidebarData={allGuide[lang.code]} />;
};

export default GuidePages;

export async function getStaticPaths({ locales }: { locales: any }) {
  const allGuide = await client.query({
    query: gql`
      ${guidePageAllGuideQuery}
    `,
    variables: { language: "EN" },
  });

  const paths: any[] = [];

  !allGuide.loading &&
    !allGuide.error &&
    allGuide.data &&
    allGuide.data.allGuide?.nodes
      .map((el: any) => {
        return el.children.nodes.map((subEl: any) => {
          return paths.push({
            params: { href: el.slug, sub: subEl.slug },
          });
        });
      })
      .flat();

  return {
    paths,
    fallback: false,
  };
}

export async function getStaticProps(context: any) {
  const languages = await client.query({
    query: gql`
      ${languageQuery}
    `,
  });

  const singleGuide = await client.query({
    query: gql`
      ${guidePageSingleGuideQuery}
    `,
    variables: {
      uri: `/faq/${context.params.href}/${context.params.sub}/`,
    },
  });

  const allGuide: any = {};
  for (let i = 0; i < languages.data.languages.length; i++) {
    allGuide[languages.data.languages[i].code] = await client.query({
      query: gql`
        ${guidePageAllGuideQuery}
      `,
      variables: {
        language: languages.data.languages[i].code,
      },
    });
  }

  return {
    props: {
      singleGuide: {
        data: singleGuide.data,
        error: singleGuide.error || null,
        loading: singleGuide.loading,
      },
      allGuide: allGuide,
    },
  };
}
